import { Button } from 'react-bootstrap';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import styled from 'styled-components';
import { IoMove as MoveIcon, IoAnalyticsOutline as DistanceIcon } from 'react-icons/io5';
import { BiShapeTriangle as AreaIcon } from 'react-icons/bi';
import { BsEraserFill as EraseIcon } from 'react-icons/bs';
import {
	LuMapPin as PointIcon,
	LuMoveVertical as HeightIcon,
	LuMap as MapIcon,
} from 'react-icons/lu';

import { useProject } from '@contexts/Project.context';
import useKeyboardShortcut from '@hooks/useKeyboardShortcut.hook';
import { KeyboardShortcut } from '../../../SharedStyles';

const TOOLS = [
	{ name: 'Move', key: 'M', icon: <MoveIcon className="mx-1" /> },
	{ name: 'Point', key: 'P', icon: <PointIcon className="mx-1" /> },
	{ name: 'Distance', key: 'D', icon: <DistanceIcon className="mx-1" /> },
	{ name: 'Height', key: 'H', icon: <HeightIcon className="mx-1" /> },
	{ name: 'Area', key: 'A', icon: <AreaIcon className="mx-1" /> },
	{ name: 'Erase', key: 'E', icon: <EraseIcon className="mx-1" /> },
];

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;

	.btn:hover {
		background: var(--bs-btn-hover-bg);
	}
`;

const Divider = styled.span`
	border-right: 1px solid hsl(0, 0%, 30%);
	align-self: stretch;
`;

let measureDialogueShown = false;

/**
 * The measuring tools of the 3D view, in the bottom toolbar: the same buttons and shortcuts as
 * the 2D measurement tools, plus Point and Height.
 */
const Measure3dTools = () => {
	const { measure3d, dispatch } = useProject();
	const { tool } = measure3d;

	const select = name => {
		dispatch({ type: 'setMeasure3dTool', payload: name });
		if (name !== 'Move' && !measureDialogueShown) {
			measureDialogueShown = true;
			dispatch({
				type: 'setDialogue',
				payload: {
					header: 'Measuring in 3D',
					body: (
						<>
							<p>
								Click on the model to place points. Distances and heights are in
								metres.
							</p>
							<p>
								Note: measurements are temporary and will not be saved. They are
								lost when you leave the 3D view or refresh the page.
							</p>
						</>
					),
					fullWidth: false,
					autoClose: true,
					dismissible: true,
				},
			});
		}
	};

	TOOLS.forEach(({ name, key }) => useKeyboardShortcut(key, name !== tool, () => select(name)));

	return (
		<Wrapper>
			<Button
				variant="dark"
				className="d-flex align-items-center gap-2"
				onClick={() => dispatch({ type: 'setView3d', payload: { active: false } })}>
				<MapIcon />
				<span>Back to map</span>
			</Button>
			<Divider />
			<ToggleButtonGroup type="radio" name="measure3d-tools" value={tool} onChange={select}>
				{TOOLS.map(({ name, key, icon }) => (
					<ToggleButton
						key={name}
						id={`radio-button-3d-${name.toLowerCase()}`}
						value={name}
						variant={tool === name ? 'success' : 'dark'}>
						{icon}
						{name}
						<KeyboardShortcut>{key}</KeyboardShortcut>
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</Wrapper>
	);
};

export default Measure3dTools;
